export default "__VITE_ASSET__qaWzGqHZ__"